exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "agm-map{\r\n    \r\n    min-height: 300px;\r\n    height: 100vh;\r\n    width: 100%;\r\n    \r\n    \r\n}\r\n\r\n\r\n\r\n\r\n@media screen and (max-width: 1500px) {\r\n    .mapa-container{\r\n        padding-left: 0px;\r\n        padding-right: 0px;\r\n        max-width: 1500px;\r\n    }\r\n} ", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Front-end/[PROYECTO] abordo-empresarial-cli4/[RAMA] actualizarAngular-Analytics/abordo-empresarial-cli4/src/app/componentes/cobertura/cobertura.component.css
// module id = ../../../../../src/app/componentes/cobertura/cobertura.component.css
// module chunks = 1